import { normalizeSizeFilters, buildSizeURL } from './virus-size-filter.js';

const initialURL = new URL(window.location.href);
if (initialURL.searchParams.getAll('filter.v.option.size').some(value => value.trim()) && !initialURL.searchParams.has('filter.v.availability')) {
  initialURL.searchParams.delete('page');
  initialURL.search = normalizeSizeFilters(initialURL.searchParams).toString();
  window.location.replace(initialURL.toString());
}

document.addEventListener('click', event => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a[data-virus-size]') : null;
  if (!link) return;
  event.preventDefault();
  window.location.assign(buildSizeURL(window.location.href, link.dataset.virusSize).toString());
});
